module.exports = __webpack_public_path__ + "static/media/profissional_photo.37c5abb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/profissional_photo.png
// module id = ./src/statics/images/profissional_photo.png
// module chunks = 0